import { Logo } from './Logo.js';
export function ComingSoon() {
  return (
    <div className="screen center">
      <Logo height={40} />
      <h1>xchange is almost ready</h1>
      <p className="hint">Buy and sell Gaju for USDC (Solana), right here in Telegram.</p>
      <p className="hint">
        We are testing with a small group first. You will get a message from this bot when it opens.
      </p>
    </div>
  );
}
